export const eventTypes = {
    // Events we produce
    VENUE_CLICK: 'evelin:productInfo:venueClick',
    VENUES_MAP_CLICK: 'evelin:productInfo:venuesMapClick',
    RATINGS_CLICK: 'evelin:buybox:ratingsClick',
    BUYBOX_SELECTION_CHANGE: 'evelin:buybox:selectionChange',
    OPEN_SHARE_MODAL: 'evelin:buybox:openShareModal',

    // Events we consume
    BUYBOX_RATINGS_CLICK: 'evelin:buybox:ratingsClick',
    BUYBOX_OPEN_SHARE_MODAL: 'evelin:buybox:openShareModal',

    NAVIGATE_CART: 'evelin:navigate:cart',
};
